export type GridRow = Record<string, any> & {
  leadId?: string | number;
  id?: string | number;
  contactId?: string | number;
  companyContactId?: string | number;
  borrowerId?: string | number;
};

export const getLeadRow = (rows: GridRow[], id?: string | null) => {
  if (!id) return undefined;
  const sid = String(id);
  return rows.find(r => {
    const candidates = [
      r.leadId,
      r.contactId
    ];
    return candidates.some(v => v != null && String(v) === sid);
  });
};

export const getLeadLabel = (rows: GridRow[], id?: string | null) => {
  const row = getLeadRow(rows, id);
  if (!row) return id ? `Lead #${String(id)}` : '';
  const fullName = [row?.firstName, row?.lastName].filter(Boolean).join(' ').trim();
  const altName = (row as any)?.name || (row as any)?.fullName || (row as any)?.company;
  return fullName || altName || `Lead #${String(id)}`;
};

export const getLeadPhone = (rows: GridRow[], id?: string | null) => {
  const row = getLeadRow(rows, id) || ({} as GridRow);
  const candidates = [
    row?.phone
  ].filter(Boolean) as string[];
  return (candidates[0] || '').toString().trim();
};

export const normalizeToE164 = (raw: string, defaultCountryPrefix = '+1'): string => {
  const digits = (raw || '').replace(/\D+/g, '');
  if (!digits) return '';
  if ((raw || '').startsWith('+')) return raw;
  if (digits.length === 10 && defaultCountryPrefix === '+1') return `${defaultCountryPrefix}${digits}`;
  if (digits.length > 0) return `+${digits}`;
  return '';
};
